<div *ngIf="aberta && solicitacao" class="modal-backdrop-custom" (click)="fechar.emit()">
  <div class="modal-card modal-portaria" (click)="$event.stopPropagation()">
    <div class="modal-header-custom">
      <h3 class="h5 mb-0">{{ salva ? 'Portaria gravada' : 'Deferir férias' }}</h3>
      <button type="button" class="btn btn-light btn-sm" (click)="fechar.emit()" aria-label="Fechar">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body-custom" *ngIf="!salva">
      <p class="text-secondary small mb-3">
        O número da portaria é gerado automaticamente no controle oficial e fica registrado no usuário logado.
      </p>

      <div class="row g-3">
        <div class="col-md-8">
          <label class="form-label">Servidor</label>
          <input class="form-control" [value]="solicitacao.matricula + ' - ' + solicitacao.nome" readonly>
        </div>
        <div class="col-md-4">
          <label class="form-label">Cargo</label>
          <input class="form-control" [value]="solicitacao.cargo || ''" readonly>
        </div>
        <div class="col-md-6">
          <label class="form-label">Departamento do Servidor</label>
          <input class="form-control" [value]="solicitacao.departamento || ''" readonly>
        </div>
        <div class="col-md-6">
          <label class="form-label">Cidade / UF do empregador</label>
          <input class="form-control" [value]="(solicitacao.cidade || '') + (solicitacao.uf ? ' / ' + solicitacao.uf : '')" readonly>
        </div>
        <div class="col-md-8">
          <label class="form-label" for="secretariaPortaria">Secretaria</label>
          <select class="form-select" id="secretariaPortaria" [(ngModel)]="secretariaId" name="secretariaPortaria" required>
            <option value="">Selecione</option>
            <option *ngFor="let item of secretarias" [value]="item.id">{{ item.nome }}</option>
          </select>
          <div class="form-text" *ngIf="!secretarias.length">Cadastre uma secretaria em Férias &gt; Secretarias.</div>
        </div>
        <div class="col-md-4">
          <label class="form-label">Dias do período</label>
          <input class="form-control" [value]="dias || ''" readonly>
        </div>
        <div class="col-md-4">
          <label class="form-label" for="periodoAquisitivo">Período aquisitivo</label>
          <input
            class="form-control"
            id="periodoAquisitivo"
            name="periodoAquisitivo"
            [(ngModel)]="periodoAquisitivo"
            (ngModelChange)="mascararPeriodo()"
            placeholder="aaaa-aaaa"
            maxlength="9"
            required>
        </div>
        <div class="col-md-4">
          <label class="form-label" for="inicioPortaria">Início</label>
          <input class="form-control" id="inicioPortaria" type="date" name="inicioPortaria" [(ngModel)]="dataInicio" required>
        </div>
        <div class="col-md-4">
          <label class="form-label" for="fimPortaria">Término</label>
          <input class="form-control" id="fimPortaria" type="date" name="fimPortaria" [(ngModel)]="dataFim" required>
        </div>
        <div class="col-md-6">
          <label class="form-label">Gabinete da secretaria</label>
          <input class="form-control" [value]="gabinete" readonly>
        </div>
        <div class="col-md-6">
          <label class="form-label">Secretário / Secretária</label>
          <input class="form-control" [value]="secretario ? secretario.nome : 'Cadastre no empregador'" readonly>
        </div>
        <div class="col-md-6">
          <label class="form-label">Data atual</label>
          <input class="form-control" [value]="servico.dataHojeExtenso()" readonly>
        </div>
        <div class="col-md-6">
          <label class="form-label">Número da portaria</label>
          <input class="form-control" value="Gerado automaticamente ao salvar" readonly>
        </div>
        <div class="col-12">
          <label class="form-label" for="parecerPortaria">Parecer</label>
          <input
            class="form-control"
            id="parecerPortaria"
            name="parecerPortaria"
            [ngModel]="parecer"
            (ngModelChange)="parecerChange.emit($event)"
            maxlength="200"
            placeholder="Opcional">
        </div>
      </div>
    </div>

    <div class="modal-body-custom" *ngIf="salva">
      <p class="mb-2">
        Portaria nº <strong>{{ salva.portariaNumero }}/{{ salva.portariaAno }}</strong> gravada para
        {{ salva.nome }}.
      </p>
      <p class="text-secondary mb-0">Deseja exportar o documento preenchido em formato Word (.doc)?</p>
    </div>

    <div class="modal-footer-custom">
      <button type="button" class="btn btn-outline-secondary" (click)="fechar.emit()" [disabled]="salvando">
        {{ salva ? 'Fechar' : 'Cancelar' }}
      </button>
      <button
        *ngIf="!salva"
        type="button"
        class="btn btn-success"
        [disabled]="!formularioValido || salvando"
        (click)="confirmarSalvar()">
        {{ salvando ? 'Salvando...' : 'Salvar portaria' }}
      </button>
      <button
        *ngIf="salva"
        type="button"
        class="btn btn-primary"
        (click)="exportarDocumento()">
        Exportar .doc
      </button>
    </div>
  </div>
</div>
